import { render, staticRenderFns } from "./PersonalTotpSettings.vue?vue&type=template&id=1a5552f8&scoped=true"
import script from "./PersonalTotpSettings.vue?vue&type=script&lang=js"
export * from "./PersonalTotpSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalTotpSettings.vue?vue&type=style&index=0&id=1a5552f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5552f8",
  null
  
)

export default component.exports